export const SET_TITHELIES = 'SET_TITHELIES';
export const SET_TITHELY = 'SET_TITHELY';
export const ADD_TITHELY = 'ADD_TITHELY';
export const ADD_TITHELIES = 'ADD_TITHELIES';
export const UPDATE_TITHELY = 'UPDATE_TITHELY';
export const REMOVE_TITHELY = 'REMOVE_TITHELY';
export const CLEAR_TITHELY = 'CLEAR_TITHELY';
export const CLEAR_TITHELIES = 'CLEAR_TITHELIES';
